import { createContext, useContext } from "react";

export interface FormFlowStepSyncContextValue {
  syncCurrentStepData: (data: unknown) => void;
}

export const FormFlowStepSyncContext =
  createContext<FormFlowStepSyncContextValue | null>(null);

export const useFormFlowStepSync = () => useContext(FormFlowStepSyncContext);
